import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleNavClick = () => {
    window.dispatchEvent(new CustomEvent('nova-navigate', {
      detail: 'home'
    }));
    setIsMobileMenuOpen(false);
  };
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Sobre Nosotros',
    href: '#nosotros'
  }, {
    name: 'Portafolio',
    href: '#portafolio'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-transparent border-b border-transparent`} data-id="element-230">
      <div className="max-w-7xl mx-auto px-6 flex flex-row items-center justify-between py-4" data-id="element-231">
        {/* Logo */}
        <a href="#inicio" onClick={handleNavClick} className="flex items-center gap-2" data-id="element-232">
          <img src="https://cdn.magicpatterns.com/uploads/igjcstjpy9QDbPwmS8aSgJ/logotipo_trasnparente.png" alt="NovaWeb Logo" className="w-[140px] object-contain" style={{
          filter: 'drop-shadow(0 0 10px rgba(0, 191, 255, 0.3))'
        }} data-id="element-233" />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-234">
          <div className="flex items-center gap-6" data-id="element-235">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={handleNavClick} className="hover:text-nova-accent transition-colors font-medium text-[18px] text-[#A0AEC0] hover:text-[#00D4FF]" data-id="element-236">
                {link.name}
              </a>)}
          </div>

          <a href="#contacto" onClick={handleNavClick} className="bg-gradient-to-r from-[#00D4FF] to-[#0080FF] text-nova-bg px-8 py-3 rounded-full font-bold text-sm tracking-wide hover:opacity-90 transition-all duration-300 shadow-[0_0_15px_rgba(0,212,255,0.3)]" data-id="element-237">
            COTIZAR AHORA
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-nova-text hover:text-nova-accent transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-238">
          {isMobileMenuOpen ? <X size={24} data-id="element-239" /> : <Menu size={24} data-id="element-240" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-241">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="md:hidden absolute top-full left-0 right-0 bg-[#0A0F1E]/95 border-t border-[#00D4FF]/10 shadow-[0_10px_30px_rgba(0,0,0,0.5)]" data-id="element-242">
            <div className="flex flex-col p-6 gap-4" data-id="element-243">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={handleNavClick} className="text-nova-text hover:text-nova-accent transition-colors text-lg font-medium py-2 border-b border-[#1E2A3A]" data-id="element-244">
                  {link.name}
                </a>)}
              <a href="#contacto" onClick={handleNavClick} className="bg-gradient-to-r from-[#00D4FF] to-[#0080FF] text-nova-bg px-8 py-4 rounded-full font-bold text-base text-center mt-2" data-id="element-245">
                COTIZAR AHORA
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}